import { Component, Input, ChangeDetectionStrategy, Inject, OnChanges } from '@angular/core';
import { IDataService, IParsedDataResponse } from '../../../../services/data/data-service.interface';

@Component({
  selector: 'gtd-ui-field-crm-currency',
  templateUrl: './crm-currency.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CrmCurrencyComponent implements OnChanges {
  @Input() customClass = '';

  @Input() set data(data: number | string | any) {
    this.value = isNaN(data) ? '0.00' : Number(data).toFixed(2);
  }

  @Input() currencyCode: string;

  public value: string;
  public currency: string;
  public position: string;

  private globalData: IParsedDataResponse;

  constructor(@Inject('IDataService') private dataService: IDataService) {
    this.globalData = this.dataService.getData();
  }

  public ngOnChanges() {
    const defaultCurrency = this.globalData.default_currency || {};
    const code = this.currencyCode || defaultCurrency.currency;
    this.currency = this.getCurrencySymbol(code);
    this.position = defaultCurrency.position;
  }

  private getCurrencySymbol(code: string): string {
    const defaultCurrencies = this.dataService.getData().default_currencies;
    return Object.entries(defaultCurrencies).find((kv) => kv[1] === code)?.[0] ?? code;
  }
}
